<ng-container>
    <app-notification #note />
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</ng-container>
